import { Component, OnInit, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { Router, ActivatedRoute, RouterLink } from "@angular/router";
import { MessageService, ConfirmationService } from "primeng/api";
import { Observable, of } from "rxjs";
import { AbstractFormComponent } from "src/app/common/abstract-edit.component";
import {
  BUSINESS_STATE_LIST,
  COUNTRY_LIST,
  FISCAL_CODE_VALIDATOR_REGEX,
  PARAM_COMPANY_PATH,
  SEX_LIST,
  STATE_LIST,
} from "src/app/constants/constants";
import { Company } from "src/app/models/company";
import { CompanyService } from "src/app/services/company.service";
import { Bind } from "primeng/bind";
import { ButtonDirective } from "primeng/button";
import { Tabs, TabList, Tab, TabPanels, TabPanel } from "primeng/tabs";
import { Ripple } from "primeng/ripple";
import { SelectButton } from "primeng/selectbutton";
import { InputText } from "primeng/inputtext";
import { InputMask } from "primeng/inputmask";
import { Select } from "primeng/select";

import { Textarea } from "primeng/textarea";
import { ConfirmDialog } from "primeng/confirmdialog";
import { Toast } from "primeng/toast";
import { TranslatePipe } from "@ngx-translate/core";

import { TPipe } from "../../../i18n/t.pipe";
import { PhoneInputComponent } from "../../../components/phone-input/phone-input.component";
@Component({
    standalone: true,
    selector: "app-company-form",
    templateUrl: "./company-form.component.html",
    imports: [PhoneInputComponent, TPipe, FormsModule, ReactiveFormsModule, Bind, ButtonDirective, RouterLink, Tabs, TabList, Ripple, Tab, TabPanels, TabPanel, SelectButton, InputText, InputMask, Select, Textarea, ConfirmDialog, Toast, TranslatePipe]
})
export class CompanyFormComponent
  extends AbstractFormComponent<Company>
  implements OnInit
{
  protected fb: FormBuilder;
  private companyService = inject(CompanyService);

  pageTitle: string;
  form: FormGroup;
  idField = "id";
  formFields = [
    "id",
    "name",
    "city",
    "zip",
    "address",
    "province",
    "region",
    "email",
    "phone",
    "fiscalcode",
    "fiscaltype",
    "fiscalnumber",
    "description",
    "is_featured",
    "is_active",
    "image",
  ];
  item$: Observable<Company> = of();
  stateOptions = STATE_LIST;
  businessStateOptions = BUSINESS_STATE_LIST;
  countryList = COUNTRY_LIST;
  typeList = SEX_LIST;
  service = this.companyService;

  constructor() {
    const fb = inject(FormBuilder);
    const messageService = inject(MessageService);
    const confirmationService = inject(ConfirmationService);
    const router = inject(Router);
    const route = inject(ActivatedRoute);

    super(
      fb,
      messageService,
      confirmationService,
      router,
      route,
      PARAM_COMPANY_PATH,
    );

    this.fb = fb;
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Azienda";
      this.loadItem(id);
    } else {
      this.pageTitle = "Aggiungi Azienda";
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      name: ["", Validators.required],
      city: ["", Validators.required],
      zip: ["", Validators.required],
      address: ["", Validators.required],
      province: ["", Validators.required],
      region: [""],
      email: ["", Validators.required],
      phone: ["", Validators.required],
      fiscalcode: new FormControl("", Validators.compose([codFisc])),
      fiscaltype: ["", Validators.required],
      fiscalnumber: new FormControl(""),
      description: [""],
      is_featured: ["0"],
      is_active: ["0"],
      image: [""],
    });
  }

  loadItem(id: string) {
    this.service.getId(id).subscribe(
      (res) => {
        this.form.patchValue({
          name: res.name,
          city: res.city,
          zip: res.zip,
          address: res.address,
          province: res.province,
          region: res.region,
          email: res.email,
          phone: res.phone,
          fiscalcode: res.fiscalcode,
          fiscalnumber: res.fiscalnumber,
          description: res.description,
          is_featured: res.is_featured,
          is_active: res.is_active,
          fiscaltype: res.fiscaltype,
          id: res.id,
        });
      },
      (error) => (this.error = error),
    );
  }
}

export function codFisc(c: FormControl): { [s: string]: boolean } {
  if (c.value && !c.value.match(FISCAL_CODE_VALIDATOR_REGEX)) {
    return { invalidCF: true };
  }
}
